import * as React from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField
} from "@material-ui/core";
import OrderFieldsSection from "./OrderFieldsSection";

interface IProps {
    data?: any;
    medicationList: any[];
    prescriber?: any;
    showFakeOutOption?: any;
    showOrderSection?: any;
    handleSetAddInsurancePlan?: any;
}

interface IState {
    chaseRenewal: string,
    chaseStatus: string,
    completeScriptChase: any,
    daysSupply: string,
    dispenseDaysSupply: string,
    dispenseQuantity: string,
    expirationDate: any,
    fakeOutScriptChase: any,
    hoaAndCadence: boolean,
    initiateScriptChase: any,
    oneTimeFillReason: string,
    open: boolean,
    optionSelected: any,
    quantityAuthorized: string,
    quantityPerDay: string,
    quantityPerDose: string,
    refillsAuthorized: string,
    status: string,
}

class CheckoutFieldsSection extends React.Component<IProps, IState> {

    private orderFieldsSection: any;

    constructor(props: IProps) {
        super(props);
        this.handleSetAddInsurancePlan = this.handleSetAddInsurancePlan.bind(this);

        this.state = {
            chaseRenewal: 'needsrenewal',
            chaseStatus: 'complete',
            completeScriptChase: true,
            daysSupply: '30',
            dispenseDaysSupply: '30',
            dispenseQuantity: '30',
            expirationDate: '',
            fakeOutScriptChase: false,
            hoaAndCadence: false,
            initiateScriptChase: false,
            oneTimeFillReason: '',
            open: false,
            optionSelected: 'completeScriptChase',
            quantityAuthorized: '30',
            quantityPerDay: '1',
            quantityPerDose: '1',
            refillsAuthorized: '5',
            status: ''
        };

        this.handleScriptChase = this.handleScriptChase.bind(this);
        this.handleQuantityAuthorized = this.handleQuantityAuthorized.bind(this);
        this.handleDaysSupply = this.handleDaysSupply.bind(this);
        this.handleRefillsAuthorized = this.handleRefillsAuthorized.bind(this);
        this.handleDispenseQuantity = this.handleDispenseQuantity.bind(this);
        this.handleDispenseDaysSupply = this.handleDispenseDaysSupply.bind(this);
        this.handleExpirationDate = this.handleExpirationDate.bind(this);
        this.handleChaseRenewal = this.handleChaseRenewal.bind(this);
        this.handleChaseStatus = this.handleChaseStatus.bind(this);
        this.handleQuantityPerDay = this.handleQuantityPerDay.bind(this);
        this.handleQuantityPerDose = this.handleQuantityPerDose.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this)
        this.handleClose = this.handleClose.bind(this);
    }

    public handleSetAddInsurancePlan(addFirstInsurance: boolean, addSecondInsurance: boolean) {
        this.props.handleSetAddInsurancePlan(addFirstInsurance, addSecondInsurance);
    }

    public render() {
        const currentDate = new Date();
        const expirationDate = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate() - 1).toISOString().slice(0, 10);
        if (this.state.expirationDate.length === 0) {
            this.setState({expirationDate});
        }

        return (
            <Grid item xs={12}>
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    spacing={3}
                >
                    {this.props.medicationList.length > 0
                        && this.props.prescriber !== 'None'
                        && <Grid item xs>
                            <InputLabel style={{
                                color: "red",
                                fontSize: 18,
                                fontWeight: "bold",
                            }}>ScriptChase Section</InputLabel>
                        </Grid>}

                    {this.props.medicationList.length > 0
                        && this.props.prescriber !== 'None'
                        && <Grid item xs>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">ScriptChase</FormLabel>
                                <RadioGroup aria-label="scriptChase" name="scriptChase"
                                            value={this.state.optionSelected}
                                            onChange={this.handleScriptChase}
                                            style={{width: 225}}>
                                    <FormControlLabel value="initiateScriptChase" control={
                                        <Radio/>
                                    } label="Initiate ScriptChase"/>

                                    <FormControlLabel value="completeScriptChase" control={
                                        <Radio/>
                                    } label="Complete ScriptChase through PillPack"/>
                                    {this.state.optionSelected === 'completeScriptChase' &&
                                        <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
                                            Configure Rx Data Entry
                                        </Button>}

                                    {this.props.showFakeOutOption &&
                                        <FormControlLabel value="fakeOutScriptChase" control={
                                            <Radio/>
                                        } label="FakeOut ScriptChase"/>}
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    }

                    <Dialog
                        open={this.state.open}
                        keepMounted
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                        onClose={this.handleClose}
                    >
                        <DialogTitle id="alert-dialog-slide-title">{"Rx Data Entry"}</DialogTitle>
                        <DialogContent>
                            <TextField
                                autoFocus
                                label="Quantity Authorized"
                                value={this.state.quantityAuthorized}
                                onChange={this.handleQuantityAuthorized}
                                style={{padding: '10px', width: '27ch',}}
                                variant="outlined"
                            />
                            <TextField
                                label="Days Supply"
                                value={this.state.daysSupply}
                                onChange={this.handleDaysSupply}
                                style={{padding: '10px', width: '27ch',}}
                                variant="outlined"
                            />
                            <TextField
                                label="Refills Authorized"
                                value={this.state.refillsAuthorized}
                                onChange={this.handleRefillsAuthorized}
                                style={{padding: '10px', width: '27ch',}}
                                variant="outlined"
                            />
                            <TextField
                                label="Dispense Quantity"
                                value={this.state.dispenseQuantity}
                                onChange={this.handleDispenseQuantity}
                                style={{padding: '10px', width: '27ch',}}
                                variant="outlined"
                            />
                            <TextField
                                label="Dispense Days Supply"
                                value={this.state.dispenseDaysSupply}
                                onChange={this.handleDispenseDaysSupply}
                                style={{padding: '10px', width: '27ch',}}
                                variant="outlined"
                            />
                            <TextField
                                label="Expiration Date"
                                type="date"
                                value={this.state.expirationDate}
                                onChange={this.handleExpirationDate}
                                style={{padding: '10px', width: '27ch',}}
                                variant="outlined"
                            />
                            <FormControl variant="outlined" style={{padding: '10px', width: '27ch',}}>
                                <InputLabel>Chase Renewal?</InputLabel>
                                <Select
                                    value={this.state.chaseRenewal}
                                    onChange={this.handleChaseRenewal}
                                >
                                    <MenuItem value="needsrenewal">Yes - Needs Renewal</MenuItem>
                                    <MenuItem value="thirdparty">No - Third Party</MenuItem>
                                    <MenuItem value="antibiotic">No - Antibiotic</MenuItem>
                                    <MenuItem value="short_term_medication">No - Short-term Medication</MenuItem>
                                    <MenuItem value="taper">No - Taper</MenuItem>
                                    <MenuItem value="prohibit_renewal_request">No - Refills Not Allowed by Prescriber</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined" style={{padding: '10px', width: '27ch',}}>
                                <InputLabel>Quantity/Dose</InputLabel>
                                <Select
                                    value={this.state.quantityPerDose}
                                    onChange={this.handleQuantityPerDose}
                                >
                                    <MenuItem value="1">1</MenuItem>
                                    <MenuItem value="2">2</MenuItem>
                                    <MenuItem value="3">3</MenuItem>
                                    <MenuItem value="4">4</MenuItem>
                                    <MenuItem value="5">5</MenuItem>
                                    <MenuItem value="6">6</MenuItem>
                                    <MenuItem value="7">7</MenuItem>
                                    <MenuItem value="8">8</MenuItem>
                                    <MenuItem value="9">9</MenuItem>
                                    <MenuItem value="10">10</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined" style={{padding: '10px', width: '27ch',}}>
                                <InputLabel>Quantity/Day</InputLabel>
                                <Select
                                    value={this.state.quantityPerDay}
                                    onChange={this.handleQuantityPerDay}
                                >
                                    <MenuItem value="1">1</MenuItem>
                                    <MenuItem value="2">2</MenuItem>
                                    <MenuItem value="3">3</MenuItem>
                                    <MenuItem value="4">4</MenuItem>
                                    <MenuItem value="5">5</MenuItem>
                                    <MenuItem value="6">6</MenuItem>
                                    <MenuItem value="7">7</MenuItem>
                                    <MenuItem value="8">8</MenuItem>
                                    <MenuItem value="9">9</MenuItem>
                                    <MenuItem value="10">10</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined" style={{padding: '10px', width: '27ch',}}>
                                <InputLabel>Status</InputLabel>
                                <Select
                                    value={this.state.chaseStatus}
                                    onChange={this.handleChaseStatus}
                                >
                                    <MenuItem value="complete">Complete</MenuItem>
                                    <MenuItem value="data_entry">Data Entry</MenuItem>
                                    <MenuItem value="rph_check">RPH Check</MenuItem>
                                </Select>
                            </FormControl>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {this.props.medicationList.length > 0
                        && this.props.prescriber !== 'None'
                        && <Grid item xs style={{alignSelf: 'flex-start'}}>
                            <FormControl component="fieldset">
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.hoaAndCadence}
                                                onChange={() => this.setState({hoaAndCadence: !this.state.hoaAndCadence})}
                                            />
                                        }
                                        label="HOA and Cadence"
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                    }

                    {this.props.showOrderSection &&
                        <OrderFieldsSection medicationList={this.props.medicationList}
                                            prescriber={this.props.prescriber}
                                            completeScriptChase={this.state.completeScriptChase}
                                            initiateScriptChase={this.state.initiateScriptChase}
                                            handleSetAddInsurancePlan = {this.handleSetAddInsurancePlan.bind(this)}
                                            ref={(ref) => this.orderFieldsSection = ref}/>
                    }

                </Grid>
            </Grid>
        );
    }

    public handleClickOpen() {
        this.setState({open: true})
    }

    public handleClose() {
        this.setState({open: false})
    }

    public handleQuantityAuthorized(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({quantityAuthorized: event.target.value})
    }

    public handleQuantityPerDay(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({quantityPerDay: event.target.value})
    }

    public handleQuantityPerDose(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({quantityPerDose: event.target.value})
    }

    public handleDaysSupply(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({daysSupply: event.target.value})
    }

    public handleRefillsAuthorized(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({refillsAuthorized: event.target.value})
    }

    public handleDispenseQuantity(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({dispenseQuantity: event.target.value})
    }

    public handleDispenseDaysSupply(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({dispenseDaysSupply: event.target.value})
    }

    public handleExpirationDate(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({expirationDate: event.target.value})
    }

    public handleChaseRenewal(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({chaseRenewal: event.target.value})

        if (event.target.value === 'needsrenewal') {
            this.setState({oneTimeFillReason: ''});
        } else {
            this.setState({oneTimeFillReason: event.target.value});
        }
    }

    public handleChaseStatus(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({chaseStatus: event.target.value})

        if (event.target.value === 'complete') {
            this.setState({status: ''});
        } else {
            this.setState({status: event.target.value});
        }
    }

    public handleScriptChase(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({optionSelected: event.target.value})

        if (event.target.value === 'initiateScriptChase') {
            this.setState({initiateScriptChase: true});
            this.setState({completeScriptChase: false});
            this.setState({fakeOutScriptChase: false});
        } else if (event.target.value === 'completeScriptChase') {
            this.setState({initiateScriptChase: false});
            this.setState({completeScriptChase: true});
            this.setState({fakeOutScriptChase: false});
        } else if (event.target.value === 'fakeOutScriptChase') {
            this.setState({initiateScriptChase: false});
            this.setState({completeScriptChase: false});
            this.setState({fakeOutScriptChase: true});
        }
    }

    public getOrderFieldsSection() {
        return this.orderFieldsSection;
    }

    public getState() {
        return this.state;
    }
}

export default CheckoutFieldsSection
